import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ApprovalMatrix, ApprovalMatrixCreate, ApprovalMatrixFilter } from '../data/approvalMatrix';

export function createApprovalMatrixService(client: AxiosInstance) {
  return createCrudService<ApprovalMatrix, ApprovalMatrixCreate, ApprovalMatrixFilter>(
    client,
    '/workflow/ApprovalMatrix',
    'id',
  );
}

export type ApprovalMatrixService = CrudService<ApprovalMatrix, ApprovalMatrixCreate, ApprovalMatrixFilter>;
